import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-start w-full" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "flex flex-col h-full" }
const _hoisted_6 = { class: "mt-1 space-y-1 text-sm mb-7" }
const _hoisted_7 = {
  key: 0,
  class: "flex space-x-1"
}
const _hoisted_8 = { class: "text-muted" }
const _hoisted_9 = {
  key: 1,
  class: "flex space-x-1"
}
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = { class: "flex items-center mt-auto" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-base material-icons-outlined" }, " block ", -1)
const _hoisted_13 = {
  key: 0,
  class: "ml-1"
}
const _hoisted_14 = { class: "flex items-center ml-auto" }
const _hoisted_15 = {
  key: 0,
  class: "ml-1.5"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-base material-icons-outlined" }, " undo ", -1)
const _hoisted_17 = {
  key: 0,
  class: "ml-1.5 hidden md:inline"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"28px !important"},
  class: "material-icons-outlined"
}, " bar_chart ", -1)
const _hoisted_19 = {
  key: 0,
  class: "ml-1.5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiIcon = _resolveComponent("MultiIcon")!
  const _component_Timestamp = _resolveComponent("Timestamp")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CopyToClipboard = _resolveComponent("CopyToClipboard")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    marginLess: true,
    filled: _ctx.isDraft
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h4", {
          class: _normalizeClass(["mt-1.25px mr-4", { 'text-muted': _ctx.event.name.length === 0 }]),
          style: {"display":"-webkit-box","-webkit-line-clamp":"2","-webkit-box-orient":"vertical","overflow":"hidden"}
        }, _toDisplayString(_ctx.previewTitle), 3),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["mr-0 chip", {
							'chip-primary':
								_ctx.event.state === _ctx.EventState.OPEN || _ctx.event.state === _ctx.EventState.RESTRICTED,
							'chip-light': _ctx.event.state === _ctx.EventState.CLOSED,
							'chip-success': _ctx.event.state === _ctx.EventState.PLANNED,
						}])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_MultiIcon, {
                useTwoTone: _ctx.event.state === _ctx.EventState.PLANNED,
                class: _normalizeClass([{
									'': _ctx.event.state === _ctx.EventState.PLANNED,
								}, "w-6 mr-1 -mt-0.5"]),
                icons: _ctx.eventStateIcons
              }, null, 8, ["useTwoTone", "class", "icons"]),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('event_states.' + _ctx.event.state)
              }, null, 8, _hoisted_4)
            ])
          ], 2)
        ])
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.event.begin_timestamp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("event_editor.begin_timestamp")) + ":", 1),
                _createVNode(_component_Timestamp, {
                  reduced: _ctx.buttonIconsOnly,
                  value: _ctx.event.begin_timestamp
                }, null, 8, ["reduced", "value"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.event.end_timestamp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("event_editor.end_timestamp")) + ":", 1),
                _createVNode(_component_Timestamp, {
                  reduced: _ctx.buttonIconsOnly,
                  value: _ctx.event.end_timestamp
                }, null, 8, ["reduced", "value"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          (
							_ctx.allowClose && _ctx.hasBegun && _ctx.hasPrivileges([_ctx.CoursePrivilege.MANAGE_EVENTS])
						)
            ? (_openBlock(), _createBlock(_component_Btn, {
                key: 0,
                class: "",
                size: 'sm',
                variant: 'danger',
                outline: true,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  (true || !_ctx.buttonIconsOnly)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t("event_preview.close")), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_router_link, {
              class: "m-auto",
              to: { name: 'ExamEditor', params: { examId: _ctx.event.id } }
            }, {
              default: _withCtx(() => [
                (_ctx.hasPrivileges([_ctx.CoursePrivilege.MANAGE_EVENTS]))
                  ? (_openBlock(), _createBlock(_component_Btn, {
                      key: 0,
                      tooltip: _ctx.buttonIconsOnly ? _ctx.$t('misc.edit') : '',
                      outline: _ctx.buttonIconsOnly,
                      class: _normalizeClass({ 'icon-btn-primary -ml-2': _ctx.buttonIconsOnly }),
                      variant: _ctx.buttonIconsOnly ? 'icon' : 'secondary'
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass([_ctx.buttonIconsOnly ? 'text-xl' : 'text-base', 'material-icons'])
                        }, " edit ", 2),
                        (!_ctx.buttonIconsOnly)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t("event_preview.editor")), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["tooltip", "outline", "class", "variant"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["to"]),
            (
								_ctx.hasEnded && _ctx.allowClose && _ctx.hasPrivileges([_ctx.CoursePrivilege.MANAGE_EVENTS])
							)
              ? (_openBlock(), _createBlock(_component_Btn, {
                  key: 0,
                  class: "",
                  tooltip: _ctx.$t('event_preview.reopen'),
                  variant: 'icon',
                  outline: true,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('reopen')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }, 8, ["tooltip"]))
              : _createCommentVNode("", true),
            (_ctx.hasBegun)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: { name: 'ExamProgress', params: { examId: _ctx.event.id } }
                }, {
                  default: _withCtx(() => [
                    (_ctx.hasPrivileges([_ctx.CoursePrivilege.MANAGE_EVENTS]))
                      ? (_openBlock(), _createBlock(_component_Btn, {
                          key: 0,
                          variant: _ctx.buttonIconsOnly ? 'icon' : 'primary',
                          outline: true,
                          tooltip: _ctx.buttonIconsOnly ? _ctx.$t('event_preview.monitor') : ''
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass([
										_ctx.buttonIconsOnly
											? 'text-xl material-icons'
											: 'text-base material-icons-outlined',
									])
                            }, " visibility ", 2),
                            (!_ctx.buttonIconsOnly)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t("event_preview.monitor")), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["variant", "tooltip"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : (
								_ctx.hasEnded && _ctx.hasPrivileges([_ctx.CoursePrivilege.ASSESS_PARTICIPATIONS])
							)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    to: { name: 'ExamResults', params: { examId: _ctx.event.id } }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Btn, {
                        tooltip: _ctx.buttonIconsOnly ? _ctx.$t('event_preview.results') : '',
                        outline: true,
                        variant: _ctx.buttonIconsOnly ? 'icon' : 'primary'
                      }, {
                        default: _withCtx(() => [
                          _hoisted_18,
                          (!_ctx.buttonIconsOnly)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t("event_preview.results")), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["tooltip", "variant"])
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true),
            (!_ctx.isDraft && !_ctx.hasEnded)
              ? (_openBlock(), _createBlock(_component_CopyToClipboard, {
                  key: 3,
                  class: "",
                  value: _ctx.permalink,
                  iconOnly: true,
                  title: _ctx.$t('event_preview.copy_link'),
                  confirmationMessage: _ctx.$t('event_preview.copied_link'),
                  tooltip: _ctx.$t('help_texts.copy_exam_link')
                }, null, 8, ["value", "title", "confirmationMessage", "tooltip"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["filled"]))
}